import React from 'react';

export default function InfinityPreloader() {
  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center" data-testid="infinity-preloader">
      <div className="flex flex-col items-center gap-4">
        <svg
          width="120"
          height="84"
          viewBox="0 0 120 84"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="infinity-preloader-svg"
        >
          <defs>
            <linearGradient id="preload-left" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0A60A7" />
              <stop offset="50%" stopColor="#1590C0" />
              <stop offset="100%" stopColor="#20C0B5" />
            </linearGradient>
            <linearGradient id="preload-right" x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#30CCA0" />
              <stop offset="50%" stopColor="#57D37C" />
              <stop offset="100%" stopColor="#80E390" />
            </linearGradient>
            <linearGradient id="preload-diamond" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#E84A6C" />
              <stop offset="100%" stopColor="#FF6B8A" />
            </linearGradient>
          </defs>
          <path
            d="M60 42 C60 42 52 18 32 18 C12 18 4 30 4 42 C4 54 12 66 32 66 C52 66 60 42 60 42"
            stroke="url(#preload-left)"
            strokeWidth="9"
            strokeLinecap="round"
            fill="none"
            className="infinity-path-left"
          />
          <path
            d="M60 42 C60 42 68 18 88 18 C108 18 116 30 116 42 C116 54 108 66 88 66 C68 66 60 42 60 42"
            stroke="url(#preload-right)"
            strokeWidth="9"
            strokeLinecap="round"
            fill="none"
            className="infinity-path-right"
          />
          <rect x="48" y="2" width="7" height="7" rx="1" fill="url(#preload-diamond)" transform="rotate(15 51.5 5.5)" className="infinity-diamond" style={{ animationDelay: '0s' }} />
          <rect x="58" y="5" width="6" height="6" rx="1" fill="url(#preload-diamond)" transform="rotate(-5 61 8)" className="infinity-diamond" style={{ animationDelay: '0.2s' }} />
          <rect x="54" y="11" width="5" height="5" rx="1" fill="url(#preload-diamond)" transform="rotate(20 56.5 13.5)" className="infinity-diamond" style={{ animationDelay: '0.4s' }} />
        </svg>
        <span className="text-txt-muted text-xs tracking-widest uppercase font-heading">Loading</span>
      </div>
    </div>
  );
}
